module.exports = __webpack_public_path__ + "assets/3-San-Francisco-Recruiting-Agency.6b904a41.png";